import {
  CARGOS_SELECT_ROLES,
  PROYECTOS_ROLES,
  findRolDefByDb,
  type ProyectosRolDef,
  type ProyectosRolId,
} from "../config/proyectosRolesCatalog";

function decodeLs(key: string): string {
  try {
    const raw = localStorage.getItem(key);
    return raw ? atob(raw).trim() : "";
  } catch {
    return "";
  }
}

function normalizeRolRaw(raw: string): string {
  const r = String(raw || "")
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/\p{M}/gu, "");
  if (r.includes("admin")) return "administrador";
  if (r === "jefe" || r.includes("jefe de")) return "jefe";
  if (r === "factibilidad") return "factibilidad";
  if (r === "disenador" || r.includes("disen")) return "disenador";
  if (r === "liquidacion_diseno" || (r.includes("liquid") && r.includes("disen"))) {
    return "liquidacion_diseno";
  }
  if (r === "supervisor") return "supervisor";
  if (r === "operacion" || r === "operación") return "operacion";
  if (r === "mantenimiento") return "mantenimiento";
  if (r === "laboratorio") return "laboratorio";
  if (r.includes("control") && r.includes("energ")) return "control_energia";
  if (r === "control_energia") return "control_energia";
  if (r.includes("proye") || r === "proyectos") return "operacion";
  return r;
}

export function getProyectosRolRaw(): string {
  return decodeLs("Role").toLowerCase();
}

export function getProyectosCargoId(): string {
  return decodeLs("CargoId");
}

const ADMIN_ROL_DEF = PROYECTOS_ROLES.find((r) => r.id === "administrador")!;

/** Administrador por cargo (id 1) o por nombre de rol en sesión. */
function sesionEsAdministrador(): boolean {
  if (getProyectosCargoId() === "1") return true;
  return normalizeRolRaw(getProyectosRolRaw()) === "administrador";
}

export function resolveProyectosRolDef(): ProyectosRolDef {
  if (sesionEsAdministrador()) return ADMIN_ROL_DEF;
  const cargoId = getProyectosCargoId();
  const byCargo = CARGOS_SELECT_ROLES.find((c) => String(c.id) === cargoId);
  if (byCargo) {
    const found = findRolDefByDb(byCargo.rolDb);
    if (found) return found;
  }
  const rolDb = normalizeRolRaw(getProyectosRolRaw());
  const byRol = findRolDefByDb(rolDb);
  if (byRol) return byRol;
  return PROYECTOS_ROLES.find((r) => r.id === "operacion")!;
}

export function getProyectosRolId(): ProyectosRolId {
  return resolveProyectosRolDef().id;
}

export function isProyectosAdminRole(): boolean {
  return sesionEsAdministrador() || getProyectosRolId() === "administrador";
}

export function isProyectosJefeRole(): boolean {
  return getProyectosRolId() === "jefe" || isProyectosAdminRole();
}

export function isProyectosFactibilidadRole(): boolean {
  return getProyectosRolId() === "factibilidad";
}

export function isProyectosDisenadorRole(): boolean {
  return getProyectosRolId() === "disenador";
}

export function isProyectosLiquidacionDisenoRole(): boolean {
  return getProyectosRolId() === "liquidacion_diseno";
}

export function puedeGestionarLiquidacionDiseno(): boolean {
  return isProyectosAdminRole() || isProyectosLiquidacionDisenoRole();
}

export function puedeGestionarInformeAvanceObra(): boolean {
  const rol = getProyectosRolId();
  return isProyectosAdminRole() || rol === "supervisor" || rol === "jefe";
}

export function canConfigurarPermisosAdicionales(): boolean {
  if (isProyectosAdminRole()) return true;
  return resolveProyectosRolDef().puedeConfigurarPermisosAdicionales;
}

/** Menú lateral: el administrador ve todas las rutas del módulo. */
export function canAccessMenuRoute(route: string): boolean {
  if (isProyectosAdminRole()) return true;
  return resolveProyectosRolDef().menuRoutes.includes(route);
}

/** 0–5 = etapas del proyecto; el administrador accede a todas. Tab 1 = expediente (todos los roles). */
export function canAccessGestionTab(tabIndex: number): boolean {
  if (isProyectosAdminRole()) return true;
  if (tabIndex === 1) return true;
  return resolveProyectosRolDef().gestionTabs.includes(tabIndex);
}
